module.exports = __webpack_public_path__ + "img/logo4.d78cd8a3.png";